import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { OidcAuthProvider } from "./auth/OidcProvider";
import { fetchRuntimeConfig, readOidcRuntimeConfig } from "./auth/config";
import "./styles/styles.css";
import { applyTheme } from "./styles/theme";

function ConfigurationError({ missing }: { missing: string[] }) {
  return (
    <main className="app-shell">
      <section className="panel narrow">
        <p className="eyebrow">Configuration</p>
        <h1>OIDC settings are missing</h1>
        <p className="muted">
          Create a <code>.env.local</code> file and provide the required Vite
          variables before starting the app.
        </p>
        <pre className="code-block">{missing.join("\n")}</pre>
      </section>
    </main>
  );
}

async function bootstrap() {
  const runtimeConfig = await fetchRuntimeConfig();
  const configResult = readOidcRuntimeConfig(runtimeConfig);
  const rootElement = document.getElementById("root");

  applyTheme();

  if (!rootElement) {
    throw new Error("Root element #root was not found.");
  }

  createRoot(rootElement).render(
    <StrictMode>
      {configResult.ok ? (
        <OidcAuthProvider config={configResult.config}>
          <App config={configResult.config} />
        </OidcAuthProvider>
      ) : (
        <ConfigurationError missing={configResult.missing} />
      )}
    </StrictMode>
  );
}

bootstrap();
